/*
 * Title: Expiry Date Fix Page
 * Description: Wrapper for the expiry-date-only fixing tool — direct URL only, fixing group
 * Date: 2026-09-23
 */
import { ExpiryFixProvider } from '../expiryDateFixing/ContextAPI';
import Index from '../expiryDateFixing/Index';

export default function ExpiryDateFixing() {
    return (
        <ExpiryFixProvider>
            <Index />
        </ExpiryFixProvider>
    );
}
